import React, { useEffect, useState } from 'react';
import {ClockCircleOutlined, DoubleRightOutlined, RightOutlined, SearchOutlined, UserOutlined, TagOutlined, CheckOutlined} from "@ant-design/icons";
import {Input, Divider, Typography, Card, Button} from "antd";
import {Link, useHistory} from "react-router-dom";
import {APP_PREFIX_PATH} from "../../../../configs/AppConfig";
import {useDispatch, useSelector} from "react-redux";
import {DIR_RTL} from "../../../../constants/ThemeConstant";
import {getAttachment} from 'utils/attachment';
import { changePromotionsQuantity, getPromotion } from 'redux/actions';
import moment from 'moment';
import { VaucherIcon } from 'assets/svg/icon';
import PinnedBox from './pinnedBox';

const {Text} = Typography

function MenuStaticContent() {

    const history = useHistory()
    const dispatch = useDispatch()
    const {theme:{direction, locale}, fetchedData:{logo, storeData, promotions}, cartData: {promotionsQuantity}} = useSelector(state => state)
    const [mode, setMode] = useState('')
    const [address, setAddress] = useState({})
    const [time, setTime] = useState({})
    const [voucherApplied, setVoucherApplied] = useState(false)

    const pushPath = path => {
        localStorage.removeItem('location');
        history.push(APP_PREFIX_PATH.concat(path))
    }


    useEffect(()=>{
        dispatch(getPromotion(moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')))
        //checks home promo
        if (localStorage.getItem('applied-voucher')){
            setVoucherApplied(true)
            dispatch(changePromotionsQuantity(JSON.parse(localStorage.getItem('applied-voucher'))))
        }else{
            setVoucherApplied(false)
            dispatch(changePromotionsQuantity({}))
        }
        if (localStorage.getItem('selected-mode')!==null){
            setMode(localStorage.getItem('selected-mode'))
        // } else {
        //     setMode(!storeData?.showDeliveryText && 'pickup')
        }
        if (localStorage.getItem('selected-mode') === 'pickup'){
            setAddress(JSON.parse(localStorage.getItem('selected-branch')));
        }else if (localStorage.getItem('selected-mode') === 'delivery'){
            setAddress(JSON.parse(localStorage.getItem('selected-area')));
        }
        if (localStorage.getItem('fulfillment-time')!==null) {
            setTime(JSON.parse(localStorage.getItem('fulfillment-time')))
        }
    }, [])

    const handlePromotion = (promo) => {
        if (localStorage.getItem('applied-voucher')){
            setVoucherApplied(false)
            localStorage.removeItem('applied-voucher')
            dispatch(changePromotionsQuantity({}))
        }else{
            dispatch(changePromotionsQuantity(promo))
            setVoucherApplied(true)
            localStorage.setItem('applied-voucher', JSON.stringify(promo))
        }
    }

    return (
        <>
            <div className="mobileLogoContainer d-none">
                <div className="main-title-page mb-3 mt-2">
                    <div className='main-title-page__image'>
                        <img src={logo?.attachment?.id ? getAttachment(logo?.attachment?.id) : "/img/productsFallback.svg"} alt="logo" style={{width: '120px', height: '120px'}}/>
                    </div>
                    <h1 className="mb-0 mt-5">{locale==='en' ? storeData.nameEng : storeData.nameAr}</h1>
                </div>
                <Divider className='m-0'/>
            </div>
            <div className='d-flex text-center'>
                {storeData?.showDeliveryText && <div 
                    onClick={() => pushPath('/order-mode?mode=delivery')} 
                    className={`menu-tab__item ${(mode==='delivery' || mode==='')&&'active'} ${!(storeData?.showPickupText) && 'menu-tab__item_single'}`}
                >
                    Delivery
                </div>}
                {storeData?.showPickupText && <div 
                    onClick={() => pushPath('/order-mode?mode=pickup')} 
                    className={`menu-tab__item ${(mode==='pickup' || !storeData?.showDeliveryText) &&'active'} ${!(storeData?.showDeliveryText) && 'menu-tab__item_single'}`}
                >
                    Pickup
                </div>}
            </div>

            <div className="menu-actions mb-4">
                {/* <div className="menu-actions__item">
                    <div className='d-flex align-items-center'>
                        <UserOutlined className='menu-action__icon'/>
                        <p className='menu-action__text'><b>Orderfast</b> with one click</p>
                    </div>
                    <DoubleRightOutlined rotate={ direction === DIR_RTL ? 180 : 0 } />
                </div> */}

                {mode!=='' && <div onClick={() => pushPath('/order-mode?mode='+mode)} className="menu-actions__item">
                    <div className='d-flex align-items-center'>
                        <UserOutlined className='menu-action__icon'/>
                        <div>
                            <Text type="secondary">{mode==='pickup'?'Picking from':'Delivering to'}</Text>
                            <p className='menu-action__text font-16 '>
                                {locale==='en'? address?.nameEng : address?.nameAr}
                            </p>
                        </div>
                    </div>
                    <RightOutlined rotate={ direction === DIR_RTL ? 180 : 0 } className='menu-action__icon m-0'/>
                </div>}

                {time?.type && <div onClick={()=>pushPath('/estimated-time')}>
                    <div className="menu-actions__item">
                        <div className='d-flex align-items-center'>
                            <ClockCircleOutlined className='menu-action__icon'/>
                            <div>
                                <Text type="secondary">
                                    {time?.type==='Scheduled Order' ? 'Ready within' : time?.type?.includes('Custom') ? 'Custom Delivery' : 'Delivery time'}
                                </Text>
                                <p className='menu-action__text'>
                                    {time?.type ==='As Soon as Possible' ? time?.type : time?.type.includes('Custom') ? time?.type.slice(18) : `${time?.day?.index === 0 ? 'Today' : (time?.day?.index === 1 ? 'Tomorrow' : time?.day?.day)} ${time?.time?.openingTime} - ${time?.time?.closingTime}`}
                                </p>
                            </div>
                        </div>
                        <span className='text-project'>{ time?.type ? 
                            <RightOutlined rotate={ direction === DIR_RTL ? 180 : 0 } className='menu-action__icon m-0'/>
                         : 'Schedule'}</span>
                    </div>
                </div>}
            </div>

            {promotions?.map(item=>{
                return <Card className='' key={item?.id}>
                    <div className={"d-flex align-items-center justify-content-between"}>
                        <h3> {item?.promoCode} </h3>
                        {VaucherIcon(25)}
                    </div>
                    <div className={"promo-text m-0"}> {item?.details ?? ''} </div>
                    <div className={"promo-text m-0"}> {item?.discountType==='AMOUNT' ? `${storeData?.currency?.name ? storeData?.currency.name : "KWD"} ${item?.amount?.toFixed(3)}` : (`${item?.amount}%`)} discount</div>
                    {item?.freeDelivery && <div className={"promo-text m-0"}> Free delivery </div>}
                    <div className={"promo-text m-0"}> Applies to any order above {storeData?.currency?.name ? storeData?.currency.name : "KWD"} {item?.minimumPurchase?.toFixed(3)} </div>

                    <Button onClick={()=>handlePromotion(item)} className={"mt-3 primaryColor"} style={{color:'#52681A', borderRadius: '5px'}}>{ voucherApplied ? <><CheckOutlined className="mr-2" />Voucher applied</>:'Apply voucher'}  </Button>
                </Card>
            })}

            <Input
                onClick={() => pushPath('/search')}
                className='text-left d-flex align-items-center mb-4 order-input'
                prefix={<SearchOutlined style={{fontSize: 18}}/>}
                placeholder={'Search'}
            />
            <PinnedBox/>
        </>
    );
}

export default MenuStaticContent;